// Images
import imageDark from "../../assets/images/bg-desktop-dark.jpg";

export const darkTheme = {
  background: "#161722",
  listBackground: "#25273c",
  title: "#fafafa",
  primary: "#cacde8",
  secondary: "#4d5066",
  tertiary: "#4d5066",
  draggable: "#212336",
  blue: "#3a7bfd",
  image: imageDark,
};
